/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_Updated_AtInputs */



/**
* | output |
* | --- |
* | "Updated At" |
*
* @param {Manual_Qc_Export_Updated_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_updated_at = /** @type {((inputs?: Manual_Qc_Export_Updated_AtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_Updated_AtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mis a jour le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiert am")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornato alle")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлено в")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizado en")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新于")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新日時")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizado em")
	return /** @type {LocalizedString} */ ("Updated At")
});